module.exports = __webpack_public_path__ + "img/sketch-green-start.b8ebddf9.png";